import { useState } from 'react';
import { useSelector } from 'react-redux';

export const FETCHED_RESPONSE = "FETCHED_RESPONSE";

export default function useResponse(id) {
  const [ response, setResponse ] = useState(null);
  const [ loading, setLoading ] = useState(true);
  const [ error, setError ] = useState(null);
  const cachedResponse = useSelector((state) => state.responses.items.find((r) => r.metadata.id === id));

  if (cachedResponse && (!response || response.metadata.id !== id)) {
    setResponse(cachedResponse);
    setLoading(false);
    setError(null);
  }

  return {
    response,
    loading,
    error
  }
}
